import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getVpcCode } from 'ducks/vpc';
import { useIntl } from 'react-intl';
import Body from 'ui/Typography/Body';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import withLoadingSkeleton from 'ui/withLoadingSkeleton/withLoadingSkeleton';

const TextWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.s};
  display: flex;
  flex-direction: row;
`;

const Text = styled(Body)`
  color: ${({ theme }) => theme.colors.text};
`;

const CodeWrapper = styled.div`
  height: ${({ theme }) => theme.space.mdl};
  margin-left: ${({ theme }) => theme.space.xxs};
  font-weight: bold;
  min-width: ${({ theme }) => theme.space.xxl};
`;

const TextWithLoading = withLoadingSkeleton(Text);

const VpcText = () => {
  const { formatMessage } = useIntl();
  const vpcCode = useSelector(getVpcCode);
  // eslint-disable-next-line prettier/prettier, no-useless-escape
  const vpcFromSummaryUrlRegExMatch = document.location.href.match('\\/vpc\\/(\\d|\\w{5,7})');
  const vpcFromUrl =
    vpcFromSummaryUrlRegExMatch && vpcFromSummaryUrlRegExMatch?.length > 1
      ? vpcFromSummaryUrlRegExMatch[1]
      : '';

  return (
    <TextWrapper>
      <Text type={ThemeFontStyleTypeEnum.bodyMedium}>
        {formatMessage({ id: 'kompis.designCodeTitle' })}{' '}
      </Text>
      <CodeWrapper>
        <TextWithLoading
          loading={!vpcCode && !vpcFromUrl}
          data-testid={vpcCode}
          type={ThemeFontStyleTypeEnum.bodyMedium}
        >
          {vpcCode ? vpcCode : vpcFromUrl}
        </TextWithLoading>
      </CodeWrapper>
    </TextWrapper>
  );
};

export default VpcText;
